import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export function BookingSuccess() {
  const [sp] = useSearchParams();
  const bookingId = sp.get("booking_id");
  const sessionId = sp.get("session_id");
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!bookingId) {
      setStatus("missing");
      return;
    }
    api.get(`/bookings/${bookingId}/confirm`, { params: sessionId ? { session_id: sessionId } : {} })
      .then((r) => setStatus(r.data.status || "verified"))
      .catch(() => setStatus("error"));
  }, [bookingId, sessionId]);

  return (
    <section className="max-w-[800px] mx-auto px-6 py-32 text-center" data-testid="booking-success-page">
      <CheckCircle2 size={48} style={{ color: "var(--crest-gold)" }} className="mx-auto" />
      <h1 className="font-serif text-5xl md:text-6xl tracking-tight mt-8">Your consultation is reserved.</h1>
      <p className="text-[var(--crest-muted)] mt-6">
        Booking reference: <span className="font-mono">{bookingId}</span>
      </p>
      <p className="text-[var(--crest-muted)] mt-2">Status: <strong>{status}</strong></p>
      <p className="text-[var(--crest-muted)] mt-6 max-w-md mx-auto">
        Watch for an email confirmation with calendar details. We recommend completing the client intake form now.
      </p>
      <div className="mt-10 flex justify-center gap-4 flex-wrap">
        <Link to="/intake" className="btn-primary" data-testid="success-intake-cta">Complete Intake</Link>
        <Link to="/" className="btn-secondary">Back Home</Link>
      </div>
    </section>
  );
}

export function BookingCancelled() {
  return (
    <section className="max-w-[800px] mx-auto px-6 py-32 text-center" data-testid="booking-cancelled-page">
      <XCircle size={48} className="mx-auto text-[var(--crest-muted)]" />
      <h1 className="font-serif text-5xl md:text-6xl tracking-tight mt-8">Checkout was cancelled.</h1>
      <p className="text-[var(--crest-muted)] mt-6 max-w-md mx-auto">
        Your booking was not completed. You can try again whenever you're ready.
      </p>
      <div className="mt-10 flex justify-center gap-4">
        <Link to="/book" className="btn-primary">Try Again</Link>
        <Link to="/contact" className="btn-secondary">Contact Studio</Link>
      </div>
    </section>
  );
}
